export default "__VITE_ASSET__ClDs4D_g__"